import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import Providers from './utils/Providers';
import AppRoutes from './routes/AppRoutes';
import PropTypes from 'prop-types';

Providers.propTypes = {
  children: PropTypes.node.isRequired,
};

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Providers>
      <AppRoutes />
    </Providers>
  </StrictMode>
);
